import script from "./UserChart.vue?vue&type=script&setup=true&lang=js"
export * from "./UserChart.vue?vue&type=script&setup=true&lang=js"

import "./UserChart.vue?vue&type=style&index=0&id=2f3c01f8&lang=scss"

const __exports__ = script;

export default __exports__